export default __webpack_public_path__ + "static/media/metamike.b3e4de53.png";